import { useState, useEffect } from 'react';
import createAxiosInstance from "../utils/axiosInstance";
import { API_ENDPOINTS } from "../utils/api";
import useUserData from "./useUserData";
import { Agency } from '../type/Agency';

const useMyAgencyData = () => {
  const userData = useUserData();

  const axiosInstance = createAxiosInstance();

  const [agencyData, setAgencyData] = useState<Agency | null>(null);

  useEffect(() => {
    if (userData) {
      const getAgencyData = async () => {
        try {
          const data = await axiosInstance.get<Agency>(`${API_ENDPOINTS.BEDFINDER.GETMYAGENCY}/${userData.agencyId}`);

          setAgencyData(data.data);
          // console.log('Fetched data:', data);  // Log the fetched data
        } catch (err) {
          console.log('Error fetching data:', err instanceof Error ? err.message : err);  // Log error
        }
      };

      getAgencyData();
    }
  }, [userData]);

  return agencyData;
};

export default useMyAgencyData;
